import ToastContainerWrapper from './ToastContainerWrapper';

export default ToastContainerWrapper;



// WEBPACK FOOTER //
// ./src/components/Toasts/index.js